import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 

import { listSolutions, getSolution, listRoles, getRole } from "../utils/utilsSolution";

class SelectRole extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.handleChange = this.handleChange.bind(this);
    
    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

        return;
    
    }
 

    setup(){

        let StateChange = {
            renderState: null,

            selectSolution: false,

            label: "Role",
            idSelected: "",
            idSolution: null,

            filters: null,

            onChange: null,
            onBlur: null

        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label',this.props)){
            StateChange.label = getParam('label',this.props);
        }

        if (getParam('filters',this.props)){
            StateChange.filters = getParam('filters',this.props);
        }

        if (getParam('selectSolution',this.props)){
            StateChange.selectSolution = getParam('selectSolution',this.props);
        }


        StateChange.onChange = getParam('onChange', this.props);
        StateChange.onBlur = getParam('onBlur', this.props);

        StateChange.idSolution = getParam('idSolution', this.props);

        StateChange.idSelected = getParam('value', this.props);


        if (StateChange.selectSolution){
            this.loadSolutions();
        }
        else
        {
            this.loadRoles(StateChange.idSolution, StateChange.filters);
        }

        this.setState(StateChange);

    }

    loadSelectedRole(idRole){

        const onLoad = (data) => {
            this.setState({
                isLoaded: true,
                renderState: 'loaded',
                SelectedRole: data
            });

        }
    
        const onFail = (error) => {
            this.setState({
                isFailed: true,
                isLoaded: false
            });
        }

        this.setState({renderState: 'loading'})
        getRole(this.dsd, idRole, onLoad, onFail);
        return;
       
    };



    loadRoles(idSolution, filters){

        const onLoad = (data) => {
            this.setState({
                isLoadedRoles: true,
                renderState: 'loaded',
                Roles: data
            });

        }
    
        const onFail = (error) => {
            this.setState({
                isFailed: true,
                isLoadedRoles: false
            });
        }

        this.setState({renderState: 'loading'})
        listRoles(this.dsd, {idSolution:idSolution, ...filters}, onLoad, onFail);
        return;
        
    };


    loadSolutions(){

        const onLoad = (data) => {
            this.setState({
                isLoadedSolutions: true,
                renderState: 'loaded',
                Solutions: data
            });

        }
    
        const onFail = (error) => {
            this.setState({
                isFailed: true,
                isLoadedSolutions: false
            });
        }

        this.setState({renderState: 'loading'})
        listSolutions(this.dsd, {}, onLoad, onFail);
        return;
        
    };



    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case "idSolution":
                this.setState({"idSolution":FormFieldValue})
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        };

    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
            case "loaded":

                return(
                    <>                    

                        {this.state.selectSolution && this.state.isLoadedSolutions &&
                            <PD.Select label='Select a Solution' name='idSolution' onChange={this.handleChange} value={this.state.idSolution}>
                                {
                                    this.state.Solutions.map(
                                        (Solution, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Solution._id}>{Solution.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }


                        {this.state.isLoadedRoles &&

                            <PD.Select label={this.state.label} name={this.state.name} onChange={this.state.onChange} onBlur={this.state.onBlur} value={this.state.idSelected}>
                                {
                                    this.state.Roles.map(
                                        (Role, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Role._id}>{Role.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

    }
}


export default function SelectRole_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectRole {...props} navigation={navigation} location={location} params={params} />;
  }
